<button mat-mini-fab class="mat-mini-fab-map-control" (click)="toggleStreetView()"
  [matTooltip]="'map.control_google_streetview.tooltip' | translate" matTooltipPosition="left"
  matTooltipShowDelay="500">
  <mat-icon>streetview</mat-icon>
</button>
